import { useEffect, useState } from 'react'
import { mapApi, SearchPlaceResponse } from '../api/map'
import { useLocationStore } from '../stores/locationStore'

/**
 * 가게 이름 자동완성 (/map/suggest).
 *
 * 검색 화면(Search.tsx)의 장소 라이브 제안과 같은 규칙이다 — 300ms 디바운스,
 * 다음 입력이 오면 앞 요청은 취소, 현재 위치가 있으면 근접 보정.
 * suggest 는 자동 등록이 없어 타이핑 중에 불러도 부작용이 없다.
 *
 * keyword 가 비어 있으면 부르지 않고 결과를 비운다.
 */
export const usePlaceSuggest = (keyword: string) => {
  const userLocation = useLocationStore((state) => state.location)
  const [results, setResults] = useState<SearchPlaceResponse[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const trimmed = keyword.trim()
    if (!trimmed) {
      setResults([])
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    const controller = new AbortController()
    const timer = setTimeout(async () => {
      try {
        const response = await mapApi.suggestPlaces(
          trimmed,
          controller.signal,
          userLocation
        )
        if (controller.signal.aborted) return
        setResults(response.places)
      } catch (error) {
        if (controller.signal.aborted) return // 다음 입력에 의한 취소는 무시
        console.error('장소 제안 실패:', error)
        setResults([])
      } finally {
        if (!controller.signal.aborted) setIsLoading(false)
      }
    }, 300)
    return () => {
      clearTimeout(timer)
      controller.abort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword])

  return { results, isLoading }
}
